import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { installAuthFetchInterceptor } from './hooks/useSession'
import './index.css'

// JWT 切れ（401 / 空または Forbidden の 403）でログイン画面へ戻す
installAuthFetchInterceptor()

// PWAの自動更新処理
// AndroidのPWAで自動更新を実現するため、Service Workerの更新を検出して自動再読み込み
if ('serviceWorker' in navigator) {
  let refreshing = false;
  
  // Service Workerのコントローラーが変更されたら（更新が適用されたら）自動再読み込み
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    // 新しいService Workerが有効になったら自動的に再読み込み
    window.location.reload();
  });

  // Service Workerの更新を検出して自動再読み込み
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      // 更新が利用可能になったら自動的に再読み込み
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // 新しいService Workerがインストールされたら自動的に再読み込み
              if (!refreshing) {
                refreshing = true;
                window.location.reload();
              }
            }
          });
        }
      });
    });
  });

  // 定期的にService Workerの更新をチェック（60秒ごと）
  setInterval(() => {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.update();
      });
    });
  }, 60000);

  // ページがフォーカスされたときにも更新をチェック（Androidで重要）
  window.addEventListener('focus', () => {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.update();
      });
    });
  });

  // ページが表示されたときにも更新をチェック（Androidで重要）
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.update();
        });
      });
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
